var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaurus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.452 7.844c-2.227 3.058-4.28 5.941-7.773 6.684-.393-.044-2.009-.044-2.402 0-3.493-.786-5.59-3.67-7.773-6.684C8.797 4.087 6.002.242.5.723l.131 1.703c4.542-.393 6.812 2.753 9.476 6.423 1.747 2.402 3.494 4.849 6.07 6.29A14.41 14.41 0 0 0 6.09 28.902c0 7.951 6.462 14.417 14.41 14.417s14.41-6.466 14.41-14.417A14.41 14.41 0 0 0 24.823 15.14c2.533-1.442 4.323-3.889 6.07-6.291 2.664-3.67 4.934-6.816 9.476-6.423L40.5.723c-5.502-.481-8.34 3.407-11.048 7.12zm3.755 21.101c0 6.99-5.72 12.713-12.707 12.713-6.987 0-12.707-5.723-12.707-12.713 0-6.99 5.72-12.713 12.707-12.713 6.987 0 12.707 5.68 12.707 12.713z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurus);
export default __webpack_public_path__ + "static/media/taurus.2bbf1530d1be9a26d90c727fe9b9c3fb.svg";
export { ForwardRef as ReactComponent };